import { BaseCardValidator } from './BaseCardValidator.ts';
import { isValueNumber } from '@colonist/validation';
export class CardValidatorUnordered extends BaseCardValidator {
    get cards() {
        const cards = [];
        for(const card in this.state){
            const typedCard = Number(card);
            if (typeof typedCard != 'number') continue;
            const numberOfCards = this.state[typedCard];
            if (!CardValidatorUnordered.isCardCountValid(numberOfCards)) continue;
            if (numberOfCards == 0) continue;
            cards.push(...Array(numberOfCards).fill(typedCard));
        }
        return cards;
    }
    static isCardCountValid(numberOfCards) {
        return isValueNumber(numberOfCards);
    }
}
